import { render, staticRenderFns } from "./dialog-managerenamedocument.vue?vue&type=template&id=03c65918&"
import script from "./dialog-managerenamedocument.vue?vue&type=script&lang=js&"
export * from "./dialog-managerenamedocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports